//#region src/utils/color-theme.ts
const themeToMode = {
	light: "light",
	dark: "dark"
};
const getColorModeFromColorTheme = (colorTheme) => themeToMode[colorTheme];

//#endregion
export { getColorModeFromColorTheme };
//# sourceMappingURL=color-theme.js.map